import React from "react";
import PropTypes from "prop-types";

import Tile, {
  TileTitle,
  TileHeader,
  TileBody
} from "shared/react_components/Tile";
import DataList from "shared/react_components/DataList";

import OptionalDatumCol from "./OptionalDatumCol";

const CallerData = ({
  phoneNumber,
  repeatCaller,
  city,
  region,
  phoneType,
  verifiedZip,
  ecp
}) => {
  return (
    <Tile style={{ height: 400 }}>
      <TileHeader>
        <TileTitle>Caller Data</TileTitle>
      </TileHeader>
      <TileBody>
        <DataList className="row">
          <OptionalDatumCol label="Caller ID">{phoneNumber}</OptionalDatumCol>
          <OptionalDatumCol label="Repeat Caller">
            {repeatCaller}
          </OptionalDatumCol>
          <OptionalDatumCol label="City">{city}</OptionalDatumCol>
          <OptionalDatumCol label="Region">{region}</OptionalDatumCol>
          <OptionalDatumCol label="Phone Type">{phoneType}</OptionalDatumCol>
          <OptionalDatumCol label="Verified Zip Code">{verifiedZip}</OptionalDatumCol>
        </DataList>

        {ecp && (
          <React.Fragment>
            <h2>Enhanced Caller Profile (Data Append)</h2>
            <DataList className="row">
              <OptionalDatumCol label="Display Name">{ecp.displayName}</OptionalDatumCol>
              <OptionalDatumCol label="First Name">{ecp.firstName}</OptionalDatumCol>
              <OptionalDatumCol label="Last Name">{ecp.lastName}</OptionalDatumCol>
              <OptionalDatumCol label="Age Range">{ecp.ageRange}</OptionalDatumCol>
              <OptionalDatumCol label="Gender">{ecp.gender}</OptionalDatumCol>
              <OptionalDatumCol label="Address Type">{ecp.addressType}</OptionalDatumCol>
              <OptionalDatumCol label="Street Address">{ecp.streetAddress}</OptionalDatumCol>
              <OptionalDatumCol label="City">{ecp.city}</OptionalDatumCol>
              <OptionalDatumCol label="State">{ecp.state}</OptionalDatumCol>
              <OptionalDatumCol label="Zip">{ecp.zip}</OptionalDatumCol>
              <OptionalDatumCol label="Country">{ecp.country}</OptionalDatumCol>
              <OptionalDatumCol label="Carrier">{ecp.carrier}</OptionalDatumCol>
              <OptionalDatumCol label="Line Type">{ecp.lineType}</OptionalDatumCol>
              <OptionalDatumCol label="Is Prepaid">{ecp.prepaid}</OptionalDatumCol>
              <OptionalDatumCol label="Primary Email Address">{ecp.primaryEmailAddress}</OptionalDatumCol>
              <OptionalDatumCol label="Linked Email Addresses">{ecp.linkedEmailAddresses}</OptionalDatumCol>
              <OptionalDatumCol label="Household Income">{ecp.householdIncome}</OptionalDatumCol>
              <OptionalDatumCol label="Marital Status">{ecp.maritalStatus}</OptionalDatumCol>
              <OptionalDatumCol label="Home Owner Status">{ecp.homeOwnerStatus}</OptionalDatumCol>
              <OptionalDatumCol label="Home Market Value">{ecp.homeMarketValue}</OptionalDatumCol>
              <OptionalDatumCol label="Length Of Residence Years">{ecp.lengthOfResidenceYears}</OptionalDatumCol>
              <OptionalDatumCol label="Occupation">{ecp.occupation}</OptionalDatumCol>
              <OptionalDatumCol label="Education">{ecp.education}</OptionalDatumCol>
              <OptionalDatumCol label="Has Children">{ecp.hasChildren}</OptionalDatumCol>
              <OptionalDatumCol label="High Net Worth">{ecp.highNetWorth}</OptionalDatumCol>
            </DataList>
          </React.Fragment>
        )}
      </TileBody>
    </Tile>
  );
};

CallerData.propTypes = {
  phoneNumber: PropTypes.string,
  repeatCaller: PropTypes.string,
  city: PropTypes.string,
  region: PropTypes.string,
  phoneType: PropTypes.string,
  verifiedZip: PropTypes.string,
  ecp: PropTypes.shape({
    displayName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    ageRange: PropTypes.string,
    gender: PropTypes.string,
    addressType: PropTypes.string,
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    country: PropTypes.string,
    carrier: PropTypes.string,
    lineType: PropTypes.string,
    prepaid: PropTypes.string,
    primaryEmailAddress: PropTypes.string,
    linkedEmailAddresses: PropTypes.string,
    householdIncome: PropTypes.string,
    maritalStatus: PropTypes.string,
    homeOwnerStatus: PropTypes.string,
    homeMarketValue: PropTypes.string,
    lengthOfResidenceYears: PropTypes.string,
    occupation: PropTypes.string,
    education: PropTypes.string,
    hasChildren: PropTypes.string,
    highNetWorth: PropTypes.string
  })
};

export default CallerData;
